class modalBalanceCtrl {
    constructor($scope, $uibModalInstance, items1, logger, globalFn) {
        $scope.modaldata = items1
        if ($scope.modaldata.balance == 0 || $scope.modaldata.balance == null || $scope.modaldata.balance == undefined) {
            $scope.modaldata.balance = ''
        }
        $scope.balanceChange = function () {
            if ($scope.modaldata.balance == null || $scope.modaldata.balance == undefined || $scope.modaldata.balance == '') {
                $scope.modaldata.balance = ''
                return
            }
            if (!globalFn.isNegativeFloatNum($scope.modaldata.balance)) {
                $scope.modaldata.balance = ''
                logger.logError('扣除额大于商品不含税金额且小于0！')
                return
            }
            const _balance = globalFn.cutOutNnumber($scope.modaldata.balance, 2)
            $scope.modaldata.balance = _toFixed(_balance, 2)
        }

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            // 返回数据
            if ($scope.modaldata.balance === '' || $scope.modaldata.balance === undefined || $scope.modaldata.balance === null) {
                $scope.modaldata.balance = ''
                logger.logError('请输入扣除额！')
                return
            }
            if (!globalFn.isNegativeFloatNum($scope.modaldata.balance)) {
                $scope.modaldata.balance = ''
                logger.logError('扣除额大于商品不含税金额且小于0！')
                return
            }
            if (globalFn.Sub($scope.modaldata.amount, $scope.modaldata.balance) >= 0) {
                logger.logError('扣除额大于商品不含税金额且小于0！')
                return
            }
            $uibModalInstance.close($scope.modaldata)
        }
        // 精确n位小数
        function _toFixed(v, n) {
            return parseFloat(v).toFixed(n)
        }
    }
}

modalBalanceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'logger', 'globalFn']
export default modalBalanceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/modalRedInfoBalanceCtrl.js